/**
 * @generated SignedSource<<00130c2d7ca2cee24c602b5f85da6273>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type ExternalSpaceSubtype = "BUSINESS" | "DRIVE" | "PROJECT" | "SERVICE_DESK" | "SITE" | "SOFTWARE" | "SPACE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphJiraDc_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null | undefined;
      readonly subtype?: ExternalSpaceSubtype | null | undefined;
      readonly url?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly integrationId: string | null | undefined;
  readonly lastModifiedDate: string | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly subtype: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphJiraDcProject_AtlassianSearchPage" | "searchGraphJiraDcWorkItem_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphJiraDc_AtlassianSearchPage";
};
export type searchGraphJiraDc_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphJiraDc_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphJiraDc_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = [
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "type": "ExternalSpace"
      }
    ]
  }
],
v3 = [
  {
    "condition": "__relay_internal__pv__jsmdcenabledrelayprovider",
    "kind": "Condition",
    "passingValue": true,
    "selections": (v2/*: any*/)
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jsmdcenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphJiraDc_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "ExternalComment"
        },
        {
          "kind": "InlineFragment",
          "selections": (v3/*: any*/),
          "type": "ExternalProject"
        },
        {
          "kind": "InlineFragment",
          "selections": (v3/*: any*/),
          "type": "ExternalWorkItem"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDcProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage"
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "dc51dbd358c84c4dad2452e0bd3d5eb2";

export default node;
